/**
 * Created by Jonas Wålekvist on 2018-08-29.
 */
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {DirtyWildsSymbols} from "../symbols/DirtyWildsStateReelSymbol";

export class DirtyWildReelView extends PIXI.Container {
    get noWinLayer():PIXI.Container {
        return this._noWinLayer;
    }

    set noWinLayer(value:PIXI.Container) {
        this._noWinLayer = value;
    }

    get attentionLayer():PIXI.Container {
        return this._attentionLayer;
    }

    set attentionLayer(value:PIXI.Container) {
        this._attentionLayer = value;
    }

    get topLayer():PIXI.Container {
        return this._topLayer;
    }

    set topLayer(value:PIXI.Container) {
        this._topLayer = value;
    }

    get middleLayer():PIXI.Container {
        return this._middleLayer;
    }

    set middleLayer(value:PIXI.Container) {
        this._middleLayer = value;
    }

    get bottomLayer():PIXI.Container {
        return this._bottomLayer;
    }

    set bottomLayer(value:PIXI.Container) {
        this._bottomLayer = value;
    }

    private _noWinLayer:PIXI.Container;
    private _bottomLayer:PIXI.Container;
    private _middleLayer:PIXI.Container;
    private _topLayer:PIXI.Container;
    private _attentionLayer:PIXI.Container;

    constructor(reelId:number) {
        super();
        this._noWinLayer = new PIXI.Container();
        this._bottomLayer = new PIXI.Container();
        this._middleLayer = new PIXI.Container();
        this._topLayer = new PIXI.Container();
        this._attentionLayer = new PIXI.Container();
    }


    public addChild<T extends PIXI.DisplayObject>(...children:T[]):T {
        children.forEach((child:T) => {
            if(child instanceof StateReelSymbol) {
                if(child.symName == DirtyWildsSymbols.W) {
                    return this._middleLayer.addChild(child);
                }
            }
            return this._bottomLayer.addChild(child);
        });

        return children[0];
    }
}